import { Box, HStack, Text, VStack } from '@genial/components';
import { Typography } from '@genial/design-tokens';
import React from 'react';

import { ReportGeneratorListItemNormalized } from '../../../../../../store/reportGenerator/types';
import { reportGeneratorTableHorizontalPadding } from '../../../../constants/table';
import { reportGeneratorTheme } from '../../../../constants/theme';
import { RowActions } from '../shared/row/RowActions';
import { StatusBadge } from '../shared/row/StatusBadge';
import { useReportGeneratorItemActions } from '../shared/row/useReportGeneratorItemActions';

export interface ReportGeneratorItemProps {
  item: ReportGeneratorListItemNormalized;
  columnFlex: number[];
  onDownload: (item: ReportGeneratorListItemNormalized, onComplete: () => void) => void;
  onRetry: (item: ReportGeneratorListItemNormalized, onComplete: () => void) => void;
}

export const ReportGeneratorItemTableRow: React.FC<ReportGeneratorItemProps> = ({
  item,
  columnFlex,
  onDownload,
}) => {
  const { actionLoading, handleDownload } = useReportGeneratorItemActions({
    item,
    onDownload,
  });

  return (
    <Box
      width="full"
      minH="72px"
      px={reportGeneratorTableHorizontalPadding}
      py="20px"
      bg={reportGeneratorTheme.table.rowBg}
      borderWidth={1}
      borderColor={reportGeneratorTheme.table.borderColor}
      borderRadius={reportGeneratorTheme.table.itemBorderRadius}
      justifyContent="center">
      <HStack width="full" alignItems="center" justifyContent="flex-start">
        <VStack flex={columnFlex[0]} space="stack.quarck" pr="inline.quarck">
          <Text
            variant="bold"
            fontSize={Typography['fontsize.md']}
            color={reportGeneratorTheme.table.valueColor}
            noOfLines={1}>
            {item.documentType}
          </Text>
          {item.documentTypeSecondaryText ? (
            <Text
              fontSize={Typography['fontsize.xs']}
              color={reportGeneratorTheme.table.documentSubtitleColor}
              noOfLines={1}>
              {item.documentTypeSecondaryText}
            </Text>
          ) : null}
        </VStack>

        <Box flex={columnFlex[1]} pr="inline.quarck">
          <Text
            fontSize={Typography['fontsize.md']}
            color={reportGeneratorTheme.table.valueColor}
            noOfLines={1}>
            {item.requestedAtNormalized}
          </Text>
        </Box>

        <Box flex={columnFlex[2]} pr="inline.quarck">
          <Text
            fontSize={Typography['fontsize.md']}
            color={reportGeneratorTheme.table.valueColor}
            noOfLines={1}>
            {item.selectedPeriodDisplay}
          </Text>
        </Box>

        <Box flex={columnFlex[3]} pr="inline.quarck">
          <StatusBadge
            status={item.status}
            normalizedError={item.normalizedError}
            bgColor={item.statusIcon.bgColor}
            color={item.statusIcon.color}
          />
        </Box>

        <Box flex={columnFlex[4]} alignItems="flex-end">
          <RowActions item={item} actionLoading={actionLoading} onDownload={handleDownload} />
        </Box>
      </HStack>
    </Box>
  );
};
